
/**
 * Common numeric utils.
 */
export abstract class NumberService {

  /**
   * Rounds a number to a specified amount of places
   *
   * @param value: the value. 1.999
   * @param precision: the precision. 2
   * #returns value rounded to precision. 2
   */
  static round(value: number | undefined, precision?: number): number | undefined {
    if (value === undefined) {
      return undefined;
    }
    if (precision === undefined) {
      return Math.round(value);
    }
    const multiplier: number = Math.pow(10, precision);
    return Math.round(value * multiplier) / multiplier;
  }

  /**
   * Truncate a number to a specified amount of places
   *
   * @param value: the value. 1.999
   * @param precision: the precision. 2
   * #returns value rounded to precision. 1.99
   * #returns original value if it contians e
   */
  static truncateDecimal(value: number, precision?: number): number | undefined {
    if (value === undefined) {
      return undefined;
    }

    const numString = value.toString();
    if (precision === undefined || numString.indexOf('e') !== -1) {
      return value;
    }

    const regex = new RegExp('^-?\\d+(?:.\\d{0,' + (precision || -1) + '})?');
    const matchedValue = numString.match(regex)?.[0];
    return matchedValue !== undefined ? parseFloat(matchedValue) : undefined;
  }

  /**
   * @param value
   * @returns Number of digits after decimal point
   */
  static getPrecision(value: number): number {
    if (typeof value === 'number' && !isNaN(value)) {
      return Math.round(value) === value ? 0 : value.toString().split('.')[1].length;
    }
    return NaN;
  }

  /**
   * @param value
   * @returns true when value can be parsed as number
   */
  static isNumber(value: unknown): boolean {
    // Number() parses null and empty string as zero
    return !isNaN(parseFloat(value as string)) && !isNaN(Number(value));
  }

}
